import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Menu } from 'src/app/models/common';

@Injectable({
  providedIn: 'root'
})
export class EAPDatashareService {

  constructor() { }

  public _ApplicationID = new BehaviorSubject<string>("");
  ApplicationID = this._ApplicationID.asObservable();

  public _Currency_ID = new BehaviorSubject<string>("");
   Currency_ID = this._Currency_ID.asObservable();
   
  setCurrency_ID(value: string) {
  this._Currency_ID.next(value);
  }

  /**
   * Updates the value of the ApplicationID BehaviorSubject with the given value.
   *
   * @param value - The new application ID string to be set.
   */
  setApplicationID(value: string) {
    this._ApplicationID.next(value);
  }

  public _Application_Type_ID = new BehaviorSubject<string>("");
  Application_Type_ID = this._Application_Type_ID.asObservable();

  /**
   * Updates the value of the Application_Type_ID BehaviorSubject with the given value.
   *
   * @param value - The new application type ID string to be set.
   */
  setApplication_Type_ID(value: string) {
    this._Application_Type_ID.next(value);
  }

  public __LeftMenu = new BehaviorSubject<Menu[]>([]);
  LeftMenu = this.__LeftMenu.asObservable();

  /**
   * Updates the value of the LeftMenu BehaviorSubject with the given value.
   *
   * @param value - The new array of menu items to be set.
   */
  setLeftMenu(value: Menu[]) {
    this.__LeftMenu.next(value);
  }

  public _EAPPatientID = new BehaviorSubject<string>("");
  EAPPatientID = this._EAPPatientID.asObservable();

  /**
   * Updates the value of the EAPPatientID BehaviorSubject with the given value.
   *
   * @param value - The new EAP patient ID string to be set.
   */
  setEAPPatientID(value: string) {
    this._EAPPatientID.next(value);
  }

  public _OBJECTIVES = new BehaviorSubject<string>("");
  OBJECTIVES = this._OBJECTIVES.asObservable();

  /**
   * Updates the value of the OBJECTIVES BehaviorSubject with the given value.
   *
   * @param value - The new string value to be set.
   */
  setOBJECTIVES(value: string) {
    this._OBJECTIVES.next(value);
  }

  public _STUDY_DESIGN = new BehaviorSubject<string>("");
  STUDY_DESIGN = this._STUDY_DESIGN.asObservable();

  /**
   * Updates the value of the STUDY_DESIGN BehaviorSubject with the given value.
   *
   * @param value - The new string value to be set.
   */
  setSTUDY_DESIGN(value: string) {
    this._STUDY_DESIGN.next(value);
  }

  public _HYPOTHESIS = new BehaviorSubject<string>("");
  HYPOTHESIS = this._HYPOTHESIS.asObservable();

  /**
   * Updates the value of the HYPOTHESIS BehaviorSubject with the given value.
   *
   * @param value - The new string value to be set.
   */
  setHYPOTHESIS(value: string) {
    this._HYPOTHESIS.next(value);
  }

  public _BACKGROUND = new BehaviorSubject<string>("");
  BACKGROUND = this._BACKGROUND.asObservable();

  /**
   * Updates the value of the BACKGROUND BehaviorSubject with the given value.
   *
   * @param value - The new string value to be set.
   */
  setBACKGROUND(value: string) {
    this._BACKGROUND.next(value);
  }

  public _REGULATIONS = new BehaviorSubject<string>("");
  REGULATIONS = this._REGULATIONS.asObservable();

  /**
   * Updates the value of the REGULATIONS BehaviorSubject with the given value.
   *
   * @param value - The new string value to be set.
   */
  setREGULATIONS(value: string) {
    this._REGULATIONS.next(value);
  }

  public _TOOLS_PROCEDURES = new BehaviorSubject<string>("");
  TOOLS_PROCEDURES = this._TOOLS_PROCEDURES.asObservable();

  /**
   * Updates the value of the TOOLS_PROCEDURES BehaviorSubject with the given value.
   *
   * @param value - The new string value to be set.
   */
  setTOOLS_PROCEDURES(value: string) {
    this._TOOLS_PROCEDURES.next(value);
  }

  public _PRIMARY_OUTCOMES = new BehaviorSubject<string>("");
  PRIMARY_OUTCOMES = this._PRIMARY_OUTCOMES.asObservable();

  /**
   * Updates the value of the PRIMARY_OUTCOMES BehaviorSubject with the given value.
   *
   * @param value - The new string value to be set.
   */
  setPRIMARY_OUTCOMES(value: string) {
    this._PRIMARY_OUTCOMES.next(value);
  }

  public _SECONDARY_OUTCOMES = new BehaviorSubject<string>("");
  SECONDARY_OUTCOMES = this._SECONDARY_OUTCOMES.asObservable();

  /**
   * Updates the value of the SECONDARY_OUTCOMES BehaviorSubject with the given value.
   *
   * @param value - The new string value to be set.
   */
  setSECONDARY_OUTCOMES(value: string) {
    this._SECONDARY_OUTCOMES.next(value);
  }

  public _EapMemberOrgList = new BehaviorSubject<EAPMembersOrgExt[]>([]);
  EapMemberOrgList = this._EapMemberOrgList.asObservable();

  /**
   * Updates the value of the EapMemberOrgList BehaviorSubject with the given array of EAPMemberOrgExt objects.
   *
   * @param value - The new array of EAP members' organization extensions to be set.
   */
  setEapMemberOrgList(value: EAPMembersOrgExt[]) {
    this._EapMemberOrgList.next(value);
  }
}

export class EAPMembersOrgExt {
  public MemberOrganizationID: string;
  public MemberOrganizationName: string;
  public RoleID: string;
  public RoleName: string;
  public ID: string;
  public ApplicationID: string;
  public MemberID: string;
}
